import { Trans } from "react-i18next";
import { Button } from "@kalodata/kds-design";
import { IconLineArrowRight } from "@kalodata/kds-design-icons";
import { ContactCard } from "./ContactCard";
import { SocialIcon } from "./SocialIcon";
import { openExternal } from "./utils";
import type { Community } from "./types";

interface CommunityCardProps {
  community: Community;
}

/**
 * 社群入口卡片。
 * - 无链接但有二维码（如企业微信）：内联「图标 + 名称」标题 + 二维码（对齐设计稿，不展示描述）
 * - 有 link/schemeUrl（如 Discord/Zalo）：名称标题 + 图标 + 跳转按钮
 */
export const CommunityCard = ({ community }: CommunityCardProps) => {
  const { name, title, link, imageUrl, schemeUrl, linkText } = community;
  const target = link || schemeUrl || "";
  const hasTarget = Boolean(target);

  if (!hasTarget) {
    return (
      <ContactCard
        title={
          <span className="inline-flex items-center justify-center gap-[6px]">
            <SocialIcon name={name} className="size-[20px]" />
            {name}
          </span>
        }
      >
        {imageUrl ? (
          <img src={imageUrl} alt={name} className="size-[98px] rounded-[6px] object-contain" />
        ) : (
          <SocialIcon name={name} className="size-[36px]" />
        )}
      </ContactCard>
    );
  }

  return (
    <ContactCard title={title || name}>
      <div className="flex w-full flex-col items-center gap-[8px]">
        {imageUrl ? (
          <img src={imageUrl} alt={name} className="size-[36px] object-contain" />
        ) : (
          <SocialIcon name={name} className="size-[36px]" />
        )}

        <Button
          variant="text"
          size="sm"
          iconPlacement="end"
          icon={<IconLineArrowRight size={16} />}
          onClick={() => openExternal(target)}
          className="h-[28px] gap-[6px] px-[10px] py-[6px] text-[14px] font-medium text-kds-accent-fg"
        >
          {linkText || <Trans>Click To Join</Trans>}
        </Button>
      </div>
    </ContactCard>
  );
};
